"use strict";
"use es6";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.from = void 0;

var _FromObservable = require("./FromObservable");

var from = _FromObservable.FromObservable.create;
exports.from = from;